export function isAuthEndpoint(url: string) {
    const u = url.toLowerCase();
    return u.includes('/auth/login')
        || u.includes('/auth/refresh')
        || u.includes('/auth/register')
        || u.includes('/auth/forgot')
        || u.includes('/auth/reset');
}


export function isWebSocketEndpoint(url: string) {
    const u = url.toLowerCase();
    return u.includes('/ws/');
}
